export type DropzoneAccept = Record<string, string[]>;

const imageMimeMap: Record<string, string> = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  bmp: 'image/bmp',
  webp: 'image/webp',
  svg: 'image/svg+xml',
  tif: 'image/tiff',
  tiff: 'image/tiff',
  ico: 'image/vnd.microsoft.icon',
  heic: 'image/heic',
  heif: 'image/heif',
};

const documentMimeMap: Record<string, string> = {
  pdf: 'application/pdf',
  txt: 'text/plain',
  rtf: 'application/rtf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  odt: 'application/vnd.oasis.opendocument.text',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ods: 'application/vnd.oasis.opendocument.spreadsheet',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  odp: 'application/vnd.oasis.opendocument.presentation',
  csv: 'text/csv',
  md: 'text/markdown',
};

const audioMimeMap: Record<string, string> = {
  mp3: 'audio/mpeg',
  wav: 'audio/wav',
  aac: 'audio/aac',
  ogg: 'audio/ogg',
  flac: 'audio/flac',
  m4a: 'audio/mp4',
  wma: 'audio/x-ms-wma',
};

const videoMimeMap: Record<string, string> = {
  mp4: 'video/mp4',
  webm: 'video/webm',
  ogv: 'video/ogg',
  avi: 'video/x-msvideo',
  mov: 'video/quicktime',
  mkv: 'video/x-matroska',
  wmv: 'video/x-ms-wmv',
  flv: 'video/x-flv',
  mpeg: 'video/mpeg',
};

const archiveMimeMap: Record<string, string> = {
  zip: 'application/zip',
  rar: 'application/vnd.rar',
  '7z': 'application/x-7z-compressed',
  tar: 'application/x-tar',
  gz: 'application/gzip',
};

const codeMimeMap: Record<string, string> = {
  json: 'application/json',
  js: 'application/javascript',
  ts: 'application/typescript',
  html: 'text/html',
  css: 'text/css',
  xml: 'application/xml',
  yaml: 'application/x-yaml',
  yml: 'application/x-yaml',
};

export const mimeMap: Record<string, string> = {
  ...imageMimeMap,
  ...documentMimeMap,
  ...audioMimeMap,
  ...videoMimeMap,
  ...archiveMimeMap,
  ...codeMimeMap,
};

// 🔧 Utility: Generate react-dropzone accept object
export function generateDropzoneAccept(extensions: string[]): DropzoneAccept {
  return extensions.reduce<DropzoneAccept>((acc, ext) => {
    const cleanExt = ext.trim().toLowerCase();
    const mime = mimeMap[cleanExt];
    if (mime) {
      if (!acc[mime]) {
        acc[mime] = [];
      }
      if (!acc[mime].includes(`.${cleanExt}`)) {
        acc[mime].push(`.${cleanExt}`);
      }
    }
    return acc;
  }, {});
}
